import { BaseModel } from '@tcc-mono/shared/data-access';

export class Game extends BaseModel {
  id: string;
  name: string;
  task_alloc_policy: string;
  created_at: string;
}
